import {computed, ref, nextTick, onMounted, onUnmounted} from 'vue'

const DEFAULT_HEIGHT = 0
const DEFAULT_WIDTH = 0

// get dimensions of contentBoxSize in all browser
let getContentBoxSizeDimensions = function (contentBoxSize) {
  // chrome
  if (contentBoxSize[0]) {
    getContentBoxSizeDimensions = function (contentBoxSize) {
      const size = contentBoxSize[0]
      const width = size.inlineSize
      const height = size.blockSize

      return [width, height]
    }
  } else {
    getContentBoxSizeDimensions = function (contentBoxSize) {
      const width = contentBoxSize.inlineSize
      const height = contentBoxSize.blockSize

      return [width, height]
    }
  }

  return getContentBoxSizeDimensions(contentBoxSize)
}

export function useSizable(el) {
  const width = ref(DEFAULT_WIDTH)
  const height = ref(DEFAULT_HEIGHT)

  // So that you can watch for any change in dimensions
  const dimensionsString = computed(() => {
    return `${width.value}x${height.value}`
  })

  let sizer = null

  onMounted(() => {
    sizer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const contentBoxSize = entry.contentBoxSize

        if (contentBoxSize) {
          const [w, h] = getContentBoxSizeDimensions(contentBoxSize)

          width.value = w
          height.value = h
        }
      })
    })

    sizer.observe(el.value)

    nextTick(() => {
      width.value = el.value.offsetWidth
      height.value = el.value.offsetHeight
    })
  })

  onUnmounted(() => {
    sizer.disconnect()
  })

  return {dimensionsString, width, height, sizer}
}
